export default "<div class=\"k-card\" ng-transclude>\n</div>"